export interface InteractionMetric {
  month?: string;
  count: number;
}

export interface InteractionMetrics {
  interaction_metrics: InteractionMetric[];
}

export type InteractionMetricWithMonth = Required<InteractionMetric>;

export const MONTH_LABELS: string[] = [
  'Ene',
  'Feb',
  'Mar',
  'Abr',
  'May',
  'Jun',
  'Jul',
  'Ago',
  'Sep',
  'Oct',
  'Nov',
  'Dic',
];

export const normalizeInteractionMetrics = (
  response: any
): InteractionMetricWithMonth[] => {
  let rawData: InteractionMetric[];

  if (Array.isArray(response)) {
    rawData = response;
  } else if (response && Array.isArray(response.interaction_metrics)) {
    rawData = response.interaction_metrics;
  } else {
    rawData = [];
  }

  return rawData
    .filter(
      (item: InteractionMetric): item is InteractionMetricWithMonth =>
        !!item &&
        typeof item.count === 'number' &&
        Number.isFinite(item.count) &&
        typeof item.month === 'string' &&
        item.month.trim().length > 0
    )
    .map((item) => ({
      month: item.month.trim(),
      count: item.count,
    }));
};
